import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { products } from "../Data";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/products-breadcrumb.webp'
import ProductIntro from "../Components/ProductIntro";
import ProductWhyChoose from "../Components/ProductWhyChoose";
import Application from "../Components/Application";
import CalculatorSection from "../Components/CalculatorSection";
import Testimonials from "../Components/Testimonial";
import Cta from "../Components/Cta";
import ProductProcess from "../Components/ProductProcess";
import ProductFaqs from "../Components/ProductFaqs";
import Export from "../Components/Export";

const ProductsPg=()=>{
    const { slug } = useParams();
  const product = products.find(item => item.path === `/${slug}`);
  
  useEffect(() => {
    if (!product) return;
    document.title = product.metaTitle;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", product.metaDesc);

      let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://vigoflex.in/products/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
     product.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      product.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://vigoflex.in/products/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://vigoflex.in/files/product-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
    product.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      product.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://vigoflex.in/files/product-img.webp"
    );
  }

}, [product, slug]);

  if (!product) return <h2 className="section-heading">Product not found</h2>;
  

    return(
        <>
         {/**BREADCRUMB */}
        <Breadcrumb
        title={`VigoFlex - ${product.title}`}
        bgImage={bgImg}
      />

      {/**INTRODUCTION SECTION */}
      <ProductIntro 
      title={product.title}
        photo={product.mainImg}
          subheading={product.IntroSubHeading}
          heading={product.IntroHeading}
          desc={product.IntroText}
          desc2={product.IntroText2}
          points={product.IntroPoints}
          product1={product.sideSmallImg1}
          product1Big={product.bigImg1}
          product2={product.sideSmallImg2}
          product2Big={product.bigImg2}
          product3={product.sideSmallImg3}
          product3Big={product.bigImg3}
          photoSmall={product.smallImg}
      />

      {/**WHY CHOOSE US SECTION */}
      <ProductWhyChoose
        heading={product.whyChooseHeading}
        desc={product.whyChooseDesc}
        points={product.whyChoosePoints}
      />

      {/**APPLICATION PROCESS SECTION */}
      <ProductProcess
          process={product.process}
          headingClass={product.headingClass}
        />

         {/**APPLICATIONS SECTION */}
        <Application />

         {/**EXPORT & PACKAGING SECTION */}
        <Export />

        {/**CALCULATOR SECTION */}
        <CalculatorSection />

        {/**FAQS SECTION */}
        <ProductFaqs
          faqs={product.faqs}
        />

          {/**TESTIMONIALS SECTION */}
          <div className="products-testimonials">
        <Testimonials />
        </div>

        {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default ProductsPg;